import React, { useEffect, useState } from "react";
import '../../pages/index.css'

const StickyForm = () => {
  const [isStopped, setIsStopped] = useState(false);

  useEffect(() => {
    const form = document.getElementById("stickyForm");
    const timeline = document.getElementById("dynamic-content");

    const handleScroll = () => {
      const timelineRect = timeline.getBoundingClientRect() ;
      const formHeight = form.offsetHeight;

      if (timelineRect.bottom <= formHeight +74) {
        setIsStopped(true);
      } else {
        setIsStopped(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [formData, setFormData] = useState({
    companyName: "",
    name: "",
    email: "",
    contact: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    contact: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setErrors({
        ...errors,
        email: emailRegex.test(value) ? "" : "Invalid email address",
      });
    }

    if (name === "contact") {
      const isValidPhone = value.length >= 10 && value.length <= 11;
      setErrors({
        ...errors,
        contact: isValidPhone ? "" : "Phone number must be 10-11 digits",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!errors.email && !errors.contact) {
      console.log("Form submitted successfully:", formData);
    } else {
      console.log("Form contains errors.");
    }
  };

  return (
    <div
      className={`fixed bg-white p-4 w-72 h-100 mr-2 z-50 right-6 top-[120px] rounded-lg shadow-lg hidden lg:block sticky-form ${isStopped ? "stop-sticky" : ""}`}
      id="stickyForm"
    >
      <h5 className="text-center text-2xl text-[#0D4282] font-semibold mb-4">
        Book Consulting Call
      </h5>
      <form onSubmit={handleSubmit}>
        {["companyName", "name", "email", "contact"].map((field, index) => {
          const labelText = {
            companyName: "Company Name",
            name: "Name",
            email: "Email",
            contact: "Contact",
          }[field];

          return (
            <div key={index} className="relative mb-6">
              <input
                type={field === "email" ? "email" : "text"}
                name={field}
                id={field}
                className={`peer w-full border-b border-black text-sm py-2 px-1 font-[300] focus:outline-none `}
                value={formData[field]}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <label
                htmlFor={field}
                className="absolute opacity-50 left-0 top-1/2 transform -translate-y-1/2 text-gray-500 peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-lg peer-placeholder-shown:text-gray-400 transition-all peer-focus:top-0 peer-focus:text-sm peer-focus:text-blue-600"
              >
                {labelText}
              </label>
              {errors[field] && field !== "companyName" && (
                <p className="text-red-500 text-sm mt-1">{errors[field]}</p>
              )}
            </div>
          );
        })}

        <div className="flex justify-center py-4">
          <button
            type="submit"
            className="bg-[#E5E5E5] text-black hover:text-white py-2 px-6 rounded-full hover:bg-[#00A1E0]"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default StickyForm;
